import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DivisionFormComponent } from '../division-form/division-form.component';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { CompanyNamedLookupRequest, CompanyNamedLookupResponse } from '../../company.model';

@Component({
  selector: 'app-division-modal',
  imports: [MatDialogModule, ...SharedMaterialUIModule, DivisionFormComponent],
  templateUrl: './division-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DivisionModalComponent {
  private readonly dialogRef = inject(MatDialogRef<DivisionModalComponent>);

  readonly companyId = input.required<string>();
  readonly initialValue = input<CompanyNamedLookupResponse | null>(null);
  readonly titleText = input('Create item');
  readonly fieldLabel = input('Name');
  readonly saving = input(false);

  protected onSubmit(request: CompanyNamedLookupRequest): void {
    this.dialogRef.close(request);
  }

  protected onCancel(): void {
    this.dialogRef.close();
  }

  protected get title(): string {
    return this.initialValue() ? `Edit ${this.titleText().toLowerCase()}` : `Create ${this.titleText().toLowerCase()}`;
  }
}
